import * as React from 'react'

import {restApi} from '../../../../services/rest'
import RouterLink from '../../../common/RouterLink/RouterLink'
import SvgIcon from '../../../common/SvgIcon/SvgIcon'
import BuildLogOverviewProgress from '../../../pages/BuildPage/BuildOverviewTab/BuildOverviewProgress/BuildOverviewProgress.container'
import {useTimelineArg} from '../BuildLog.rest'
import {getFullBuildLogLinkParams} from '../BuildLog.utils'
import BuildLogTimeline from '../BuildLogTimeline/BuildLogTimeline.container'
import DownloadBuildLog from '../DownloadBuildLog/DownloadBuildLog'

import type {Props} from './BuildLogOverview.types'
import BuildLogOverviewDuration from './BuildLogOverviewDuration/BuildLogOverviewDuration.container'
import BuildLogRunningMessages from './BuildLogRunningMessages/BuildLogRunningMessages.container'
import RunningStep from './RunningStep/RunningStep.container'
import ViewThreadDumpButton from './ViewThreadDumpButton/ViewThreadDumpButton.container'

import styles from './BuildLogOverview.css'

export default function BuildLogOverview({className, buildId, running}: Props) {
  const arg = useTimelineArg(buildId)
  const {timelineIsReady} = restApi.endpoints.getBuildLogTimeline.useQuery(arg, {
    selectFromResult: ({data}) => ({timelineIsReady: Boolean(data?.stages.length)}),
  })

  return (
    <div className={className}>
      <BuildLogTimeline buildId={buildId} logTarget="popup" />
      {running && <BuildLogOverviewProgress buildId={buildId} />}
      {running && <BuildLogRunningMessages buildId={buildId} />}
      <div className={styles.links}>
        <span className={styles.leftText}>
          {running ? (
            <RunningStep buildId={buildId} />
          ) : (
            <BuildLogOverviewDuration buildId={buildId} />
          )}
        </span>
        {timelineIsReady && (
          <span className={styles.rightLinks}>
            <ViewThreadDumpButton buildId={buildId} />
            <RouterLink
              params={getFullBuildLogLinkParams({buildId})}
              className={styles.logLink}
              data-test-build-log-overview={'show-full-log'}
            >
              {WrapText => (
                <>
                  <SvgIcon icon="log" className={styles.logIcon} />
                  <WrapText>{'Show full log'}</WrapText>
                </>
              )}
            </RouterLink>
            <DownloadBuildLog buildId={buildId} />
          </span>
        )}
      </div>
    </div>
  )
}
